<template>
  <div class="createNewOrder">
       <Customer-Order :showProListCopy.sync="showProListCopy" @updataItem="updataItem(arguments)"></Customer-Order>
       <div class="header_top">
           <div style="font-size:18px">
               {{$t('other.a611')}}
           </div>
          <div style="margin-right:245px">  
                <el-button size="medium" type="danger" @click="createOrder(form)">{{$t('other.a612')}}</el-button>
                <el-button size="medium" type="primary" @click="back()">{{$t('other.a605')}}</el-button>
          </div>
       </div>
      <!-- <div class="title">自建手工单</div> -->
      <div class="receiptInfo">
          <div class="desc_title">{{$t('other.a613')}}</div>
          <el-form class="vjhkbnv" ref="form" :model="form"    :rules="rules" label-width="120px">
              <div style="display:flex;margin-bottom:20px">
                <el-form-item :label="$t('other.a518')+':'" prop="address.name">
                    <el-input v-model="form.address.name"></el-input>
                </el-form-item>
                <el-form-item :label="$t('other.a519')+':'" prop="address.phone">
                    <el-input v-model="form.address.phone"></el-input>
                </el-form-item>
                <el-form-item :label="$t('other.a626')+':'">
                    <el-input v-model="form.address.zipCode"></el-input>
                </el-form-item>
                <el-form-item :label="$t('other.a481')+':'" prop="country">
                      <el-select v-model="form.country" :placeholder="$t('other.a627')">
                            <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                  
                </el-form-item>
              </div>
              <div style="display:flex">
                <el-form-item :label="$t('other.a628')+':'" prop="address.city">
                    <el-input v-model="form.address.city"></el-input>
                </el-form-item>
                <el-form-item :label="$t('other.a629')+':'" prop="address.state">
                    <el-input v-model="form.address.state"></el-input>
                </el-form-item>
                <el-form-item :label="$t('other.a630')+':'" style="width:100%" prop="address.fullAddress">
                    <el-input v-model="form.address.fullAddress"></el-input>
                </el-form-item>

              </div>
   

            </el-form>
      </div>

      <div class="receiptInfo">
          <div class="desc_title">
              <span>{{$t('other.a379')}}</span>
              <span><el-button size="medium" type="primary" @click="showProListCopy=true">{{$t('other.a614')}}</el-button></span>
          </div>
          <div style="margin-top:20px">
              <el-table :data="form.items" style="width: 100%" border>
                <el-table-column label="Img" width="80">
                    <template slot-scope="scope">
							<div style="width:60px;height:60px;overflow:hidden"><img style="width:100%" :src="scope.row.image" /></div>
					</template>
                </el-table-column>
                <el-table-column :label="$t('other.a318')">
                    <template slot-scope="scope">
							<span >{{scope.row.itemName}}</span>
					</template>
                </el-table-column>
                <el-table-column label="sku">
                    <template slot-scope="scope">
							<span >{{scope.row.variationSku}}</span>
					</template>
                </el-table-column>
                <el-table-column :label="$t('other.a631')">
                    <template slot-scope="scope">
							<span >{{scope.row.packageLength}} x </span>
                            <span >{{scope.row.packageWidth}} x </span>
                            <span >{{scope.row.packageHeight}} /cm</span>
					</template>
                </el-table-column>
                <el-table-column :label="$t('other.a632')">
                    <template slot-scope="scope">
							<span >{{scope.row.weight}}/kg</span>
                           
					</template>
                </el-table-column>
                <el-table-column :label="$t('other.a633')">
                    <template slot-scope="scope">
                        <el-input-number @change="vkgbvm()" v-model="scope.row.variationQuantityPurchased"  :min="0"  :label="$t('other.a936')"></el-input-number>
					</template>
                </el-table-column>
                
                <el-table-column :label="$t('other.a606')">
                    <template slot-scope="scope">
                        {{scope.row.storeNum}}
					</template>
                </el-table-column>
                
                <el-table-column :label="$t('other.a33')">
                    <template slot-scope="scope">
							<div ><el-button type="primary" size="mini" @click="delItem(scope.$index)">{{$t('other.a273')}}</el-button></div>
					</template>
                </el-table-column>
              </el-table>
          </div> 
      </div>

      <div class="receiptInfo">
          <div class="desc_title">
              <span>{{$t('other.a85')}}</span>
          </div>
          <div style="margin-top:20px">
              <span class="vbknv">{{$t('other.a615')}}：{{Bulky}} /KG</span>
              <span class="vbknv">{{$t('other.a616')}}：{{totalWeight}} /KG</span>
              <span class="vbknv">{{$t('other.a617')}}：{{DxsObjParams.storeId}}</span>
              <span class="vbknv">{{$t('other.a618')}}：{{totaFee}} {{$t('other.a54')}}</span>
          </div>
          <div style="margin-top:20px">
              <span class="vbknv">
                  {{$t('other.a619')}}
                  <el-select v-model="DxsObjParams.ruleId" @change="getLogisticsOptions()" :placeholder="$t('other.a634')">
                    <el-option
                    v-for="item in logisticsOption"
                    :key="item.ruleId"
                    :label="item.logisticsName"
                    :value="item.ruleId">
                    </el-option>
                </el-select>
              </span>
              <span class="vbknv">{{$t('other.a620')}}：{{newObj.firstWeight}}KG</span>  
              <span class="vbknv">{{$t('other.a621')}}：{{newObj.firstFee}}RMB/KG</span>  
              <span class="vbknv">{{$t('other.a622')}}：{{newObj.weightFee}}RMB/KG</span>  
              <span class="vbknv">{{$t('other.a623')}}：{{newObj.type == 0 ? $t('other.a635') : newObj.type == 1 ? $t('other.a636') : $t('other.a637')}}</span>
          </div>
          
      </div>
      <div class="receiptInfo">
          <div class="desc_title">
              <span>{{$t('other.a624')}}</span>
          </div>
          <div style="margin-top:20px">
              <div>
                  <el-input
                    type="textarea"
                    :rows="2"
                    :placeholder="$t('other.a625')"
                    v-model="form.msgToStore">
                    </el-input>
              </div>
          </div>
          
      </div>
  </div>
</template>

<script>
import CustomerOrder from '../components/dialog'
import newOrdersApi from '@/api/moudles/newOrders'
import utils from '../../../../utils/utils'
export default {
data(){
    return{
        form:{
            address:{
                city:null,
                country:null,
                district:null,
                name:null,
                orderId:null,
                phone:null,
                state:null,
                town:null,
                zipCode:null,
                fullAddress:null
            },
            country:null,
            emptyOrder:false,
            flagColor:null,
            flagDes:null,
            flagId:null,
            hidden:true,
            items:[],
            logistics:'',
            messageToSeller:null,
            msgToStore:null,
            note:null,
            trackingNo:null,
            storeId:null,
            storeName:null,
            userId:JSON.parse(localStorage.getItem('userInfo')).userId,
        },

        DxsObjParams:{
            height:null,
            length:null,
            orderId:null,
            shopId:null,
            storeId:null,
            userId:null,
            weight:null,
            width:null,
            ruleId:null,
            totalVlumn:0,
            totalWeight:0
        },

        rules: {
          'address.name': [
            { required: true, message: this.$t('other.a638'), trigger: 'blur' },
          ],
          'address.city': [
            { required: true, message: this.$t('other.a639'), trigger: 'blur' },
          ],
          'address.phone': [
            { required: true, message: this.$t('other.a640'), trigger: 'blur' },
          ],
          'address.state': [
            { required: true, message: this.$t('other.a641'), trigger: 'blur' },
          ],
          'address.town': [
            { required: true, message: this.$t('other.a642'), trigger: 'blur' },
          ],
           'address.fullAddress': [
            { required: true, message: this.$t('other.a643'), trigger: 'blur' },
           ],
           country: [
            { required: true, message: this.$t('other.a644'), trigger: 'blur' },
           ],
        },
        showProListCopy:false,
        options:[{
            label:this.$t('chat.Thailand'),
            value:'TH',
        },{
            label:this.$t('h5.DSX_index_my'),
            value:'MY',
        },{
            label:this.$t('h5.DSX_index_ph'),
            value:'PH',
        },{
            label:this.$t('h5.DSX_index_vn'),
            value:'VN',
        },{
            label:this.$t('chat.Singapore'),
            value:'SG',
        },{
            label:this.$t('chat.Indonesia'),
            value:'ID',
        }],
         logisticsOption:[],
         newObj:{
             firstFee:0,
             firstWeight:0,
             weightFee:0,
            type:0
         },
         
        
    }
},
computed:{
    storeId(){
        let id=this.DxsObjParams.storeId
        return id
    },

    Bulky(){//体积重
        return this.DxsObjParams.totalVlumn
    },

    totalWeight(){//重量
        return this.DxsObjParams.totalWeight
    },

    totaFee(){
        let ttp=0
        if(this.newObj.type == 0) {
            if(this.DxsObjParams.totalWeight <= this.newObj.firstWeight){
                ttp=this.newObj.firstFee
            }else{
                ttp=(this.DxsObjParams.totalWeight-this.newObj.firstWeight)*this.newObj.weightFee + this.newObj.firstFee
            }
            
        }else if(this.newObj.type == 1){
            if(this.DxsObjParams.totalVlumn/6000 <= this.newObj.firstWeight){
                ttp=this.newObj.firstFee
            }else{
                ttp=(this.DxsObjParams.totalVlumn/6000-this.newObj.firstWeight)*this.newObj.weightFee + this.newObj.firstFee
            }

        }else if(this.newObj.type == 2){
            let falg=this.DxsObjParams.totalVlumn/6000 - this.DxsObjParams.totalWeight > 0 ? this.DxsObjParams.totalVlumn/6000 : this.DxsObjParams.totalWeight
           
            if(falg <= this.newObj.firstWeight){
                ttp=this.newObj.firstFee
            }else{
                ttp=(falg-this.newObj.firstWeight)*this.newObj.weightFee + this.newObj.firstFee
            }
        }else{
            ttp=0
        }
        return ttp
    }
},
components:{
    CustomerOrder
},

watch:{
    storeId(){
        console.log(this.storeId)
        this.getDataLogistic()
    }
},

created(){
    this.options=utils.getCountryOption()
   
},
methods:{

    vkgbvm(){
        console.log('85245',this.form.items)
        this.DxsObjParams.totalWeight=0
        this.DxsObjParams.totalVlumn=0
        this.form.items.forEach(p => {
            this.DxsObjParams.totalWeight+=(p.weight*p.variationQuantityPurchased)
            this.DxsObjParams.totalVlumn += ((p.packageHeight*p.packageLength*p.packageWidth/6000)*p.variationQuantityPurchased)
        })
        this.DxsObjParams.totalWeight=this.DxsObjParams.totalWeight.toFixed(2)
        this.DxsObjParams.totalVlumn=this.DxsObjParams.totalVlumn.toFixed(4)
    },

    getLogisticsOptions(){
        this.newObj=this.logisticsOption.find(item => item.ruleId == this.DxsObjParams.ruleId)
        console.log(this.newObj)

    },

    getDataLogistic(item){
        newOrdersApi
        .getLogisticsRuleByStore({storeId:this.storeId})
        .then(res => {
            if(res.code == 200){
                console.log('物流',res.data)
                this.logisticsOption=res.data
                
            } else{
                this.$message.warning(res.msg)
            }
        })
    },

    updataItem(list){
        console.log(list)
        console.log(list[0])
        let listArr = list[0]
        let flag=[]
        let isSameStoreId=null
        let status = true
        for(let i = 0;i<this.form.items.length;i++){
            flag.push(this.form.items[i].itemKey)
        }
        for(let i =0;i<listArr.length;i++){
        console.log('-------9')
        isSameStoreId=this.form.items.find(item => item.storeId == listArr[i].storeId)
            if(!isSameStoreId && this.form.items.length > 0){
                this.$message.warning(this.$t('other.a645'))
                status = false
                return
            }
            if(flag.indexOf(listArr[i].itemKey) == -1){
                console.log(listArr[i])
                this.form.items.push(listArr[i])
                console.log(this.form)
            }else{
                this.$message.warning(this.$t('other.a646'))
            }
        }
        if(!status){
            return
        }
        console.log(this.form.items)
        // let flag=this.form.items.find(item => item.itemKey == list[0].itemKey)
        // let isSameStoreId=this.form.items.find(item => item.storeId == list[0].storeId)

        // if(!isSameStoreId && this.form.items.length > 0){
        //     this.$message.warning(this.$t('other.a645'))
        //     return
        // }

        // if(flag){
        //     this.$message.warning(this.$t('other.a646'))
        //     return
        // }else{
        //     this.form.items.push(list[0])
        //     console.log(this.form)
        // }
        this.DxsObjParams.totalWeight=0
        this.DxsObjParams.totalVlumn=0
        this.form.items.forEach(p => {
            this.DxsObjParams.totalWeight+=p.weight
            this.DxsObjParams.totalVlumn += (p.packageHeight*p.packageLength*p.packageWidth/6000)*p.variationQuantityPurchased
        })

        this.DxsObjParams.storeId=this.form.items[0].storeId
        
    },
    

    delItem(index){
        this.$confirm(this.$t('other.a608'), this.$t("other.a142"), {
        confirmButtonText: this.$t('other.a235'),
        cancelButtonText: this.$t('other.a146'),
        type: 'warning'
        }).then(() => {
            this.form.items.splice(index,1)
        })
    },


    back(){
        if(this.$route.query.from){
            this.$router.push(this.$route.query.from)
        }else{
            this.$router.push('/pendingoreder')
        }
    },
    createOrder(form){
        this.form.logistics=this.newObj.logisticsName
        this.form.messageToSeller=this.newObj.ruleId
        this.form.shipByDate=utils.getRecentDays(3)
        

        if(!this.form.items.length){
            this.$message.warning(this.$t('other.a647'))
            return
        }

        this.$refs.form.validate((valid) => {
          if (valid) {
            newOrdersApi
            .createDxsOrder(this.form)
            .then(res => {
            if(res.code === 200 ){
            this.$message.success(this.$t('other.a648'))
            setTimeout(() => {
                this.back()
                
            },200)
            }else{
            this.$message.warning(res.msg)
            }
            })
          } else {
              this.$message.warning(this.$t('other.a649'))
            return false;
          }
        });
        
        
    },

}
}

</script>
<style lang="scss" scoped>
$linkColor: #363a3d;
.createNewOrder{
    background-color: #eee;
    height: 100vh;
    position: relative;
    padding-top:60px;


    .vbknv{
        margin-right: 20px;
    }

    .header_top{
        width: 100%;
        background-color: #fff;
        display: flex;
        justify-content: space-between;
        align-items: center;
        position: fixed;
        top: 50px;
        z-index:99;
        padding:8px 15px;
        
        box-shadow: 0 2px 6px 0 rgba($linkColor, 0.3);



       
       
    }

    
    .title{
        font-size: 18px;
        font-weight: bold;
        
    }
    .receiptInfo{
        background-color: #fff;
        box-sizing: border-box;
        
        padding: 20px 5px ;
        margin: 5px;

        .desc_title{
            font-size: 18px;
            font-weight: 500;
            display: flex;
            justify-content: space-between;
        }

        .vjhkbnv{
            /deep/  .edit-item{
                display: flex;
                justify-content: flex-start;
                align-items: center;
                color: #9797a1;
                font-size: 14px;
                height: 40px;
                margin-top: 20px;
                border-bottom: 1px solid #e3e3e3
            }

            /deep/ .el-form-item{
                margin-bottom: 0px;
            }

            /deep/ .el-form-item__content{
                border-bottom: 1px solid #000;
            }

            /deep/ .el-input__inner{
                width: 100%;
                border: none!important;
            }
            /deep/ .el-input--mini{
                width: 170px!important;
            }
        }


        
    }
}
</style>